import {
	Button,
	Col,
	DatePicker,
	Form,
	Input,
	notification,
	Row,
	Card,
	Statistic,
	Flex,
} from "antd";
import { useState } from "react";
import { api } from "../utils/Api";
import axios from "axios";
import dayjs from "dayjs";
const { RangePicker } = DatePicker;
const ModalPSITotals = ({ psiId, psiName }) => {
	const [form] = Form.useForm();
	const [loadingButton, setLoadingButton] = useState(false);
	const [hasData, setHasData] = useState(false);
	const [unitPrice, setUnitPrice] = useState(0);
	const [total, setTotal] = useState(0);
	const [apiNotification, contextHolder] = notification.useNotification();

	const openNotification = (type, message, description) => {
		apiNotification[type]({
			message: message,
			description: description,
		});
	};

	const getDataTrips = async (values) => {
		setLoadingButton(true);
		setHasData(false);

		const start = `${dayjs(values.dates[0]).year()}-${
			dayjs(values.dates[0]).month() + 1
		}-${dayjs(values.dates[0]).date()}`;
		const end = `${dayjs(values.dates[1]).year()}-${
			dayjs(values.dates[1]).month() + 1
		}-${dayjs(values.dates[1]).date()}`;

		const url =
			api +
			`/job/get/materialyards/bypsi?startDate=${start}&endDate=${end}&psiId=${psiId}`;
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);

			if (data.success) {
				let unitPrices = 0;
				let total = 0;
				if (data.payload.length > 0) {
					data.payload.map((item) => {
						unitPrices += item.unitPrice;
						total += item.loadYD3 * item.unitPrice;
					});
					unitPrices = unitPrices / data.payload.length;
				}
				setUnitPrice(unitPrices);
				setTotal(total);

				setHasData(true);
				setLoadingButton(false);
			} else {
				openNotification("error", "Error", data.message);
				setLoadingButton(false);
			}
		} catch (err) {
			console.error(err.message);
			openNotification("error", "Error", err.message);
			return null;
		}
	};

	const onFinish = (values) => {
		getDataTrips(values);
	};

	const CustomForm = () => {
		return (
			<Form
				form={form}
				layout="vertical"
				onFinish={onFinish}
				initialValues={{
					dates: [dayjs(), dayjs()],
					psi: psiName,
				}}
			>
				<Row gutter={16}>
					<Col span={12}>
						<Form.Item
							label="Dates Range"
							name="dates"
							rules={[
								{
									required: true,
									message: "Dates are required",
								},
							]}
						>
							<RangePicker
								format={"MM/DD/YYYY"}
								size="large"
								allowClear={false}
								style={{ width: "100%" }}
							/>
						</Form.Item>
					</Col>
					<Col span={12}>
						<Form.Item label="PSI" name="psi">
							<Input size="large" disabled />
						</Form.Item>
					</Col>
				</Row>

				<Button
					type="primary"
					htmlType="submit"
					size="large"
					loading={loadingButton}
					disabled={loadingButton}
				>
					Search
				</Button>
			</Form>
		);
	};

	const RenderData = () => {
		return (
			<Row gutter={16}>
				<Col span={12}>
					<Card variant="borderless">
						<Statistic title="Total" value={total} precision={2} prefix="$" />
					</Card>
				</Col>
				<Col span={12}>
					<Card variant="borderless">
						<Statistic
							title="Average Unit Price"
							value={unitPrice}
							precision={2}
							prefix="$"
						/>
					</Card>
				</Col>
			</Row>
		);
	};

	return (
		<Flex vertical gap="large">
			<CustomForm />
			{hasData && <RenderData />}
			{contextHolder}
		</Flex>
	);
};

export default ModalPSITotals;
